import { useEffect } from 'react';
import { useStore } from 'react-redux';
import { changeCurrentOrganization } from '../reducers/organization/reducer';
import { setSessionObject } from '../utilities/storage';
import { useAppDispatch } from '../reducers/hooks';
import type { RootState } from '../reducers';

export function useSyncCurrentOrganization(organizationKey: string) {
  const dispatch = useAppDispatch();
  const store = useStore<RootState>();

  useEffect(() => {
    if (!organizationKey) {
      return;
    }

    const { currentOrgKey } = store.getState().organizations;

    if (currentOrgKey === organizationKey) {
      return;
    }

    dispatch(changeCurrentOrganization(organizationKey));
    setSessionObject('currentOrganization', organizationKey);
  }, [organizationKey, dispatch, store]);
}
